import { getItem, removeItem, setItem, STORAGE_KEYS } from './local-storage';

export const generateNonce = () => {
  return window.crypto.randomUUID();
};

export const storeNonce = (nonce: string) => {
  setItem(STORAGE_KEYS.DJ_NONCE, nonce);
};

export const getStoredNonce = () => {
  return getItem(STORAGE_KEYS.DJ_NONCE) || '';
};

export const clearStoredNonce = () => {
  removeItem(STORAGE_KEYS.DJ_NONCE);
};

export const decodeToken = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(base64Url.length / 4) * 4, '=');

    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const decoded = new TextDecoder('utf-8').decode(bytes);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const validateNonce = (idToken: string): boolean => {
  const payload = decodeToken(idToken);
  if (!payload) return false;

  const storedNonce = getStoredNonce();
  if (payload.nonce !== storedNonce) {
    console.error('Nonce validation failed');
    return false;
  }
  return true;
};

export function parseHashParams(hashString?: string): Record<string, string> {
  const hash = hashString ?? window.location.hash;
  if (!hash) return {};

  const cleaned = hash.startsWith('#') ? hash.slice(1) : hash;
  const params = new URLSearchParams(cleaned);

  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}
